import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterList, beforeList } from '../data/landing';
export function ComparisonSection() {
  return <section aria-labelledby="comparacion" className="bg-white text-ink" data-id="element-39" data-mp="3e7kfa4y0b8oa">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-20" data-id="element-40" data-mp="39dg4tbpj8iig">
        <div className="rounded-3xl border border-ink/15 bg-white px-6 py-14 sm:px-10 lg:px-14 lg:py-16" data-id="element-41" data-mp="34g695ebjvam6">
          <h2 id="comparacion" className="sr-only" data-id="element-42" data-mp="2zh35nyb7xcgb">
            Antes y después de +300 Mapas Mentales de Inglés
          </h2>

          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-43" data-mp="2ve6nu9ti5kdf">
            <article className="flex flex-col" data-id="element-44" data-mp="2qfdd2p5lo7gy">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-ink/50" style={{
              color: "#E8533F"
            }} data-id="element-45" data-mp="2qg57hwngnz5n">
                Antes de +300 Mapas Mentales de Inglés
              </p>
              <h3 className="mt-4 font-display text-2xl leading-tight text-ink sm:text-3xl" data-id="element-46" data-mp="om5xrfpzlpv2">
                El problema de estudiar inglés sin un sistema
              </h3>
              <ul className="mt-8 space-y-5" data-id="element-47" data-mp="3adt9ae4qsfqu">
                {beforeList.map(item => <li key={item} className="flex gap-4" data-id="element-48" data-mp="3ehr8eou2hqjw">
                    <XIcon className="mt-1 h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-49" data-mp="30gwz83z73lk6" />
                    <span className="text-base leading-relaxed text-ink/75" data-id="element-50" data-mp="30j9qx8ur9aaf">{item}</span>
                  </li>)}
              </ul>
            </article>

            <article className="flex flex-col border-t border-ink/15 pt-10 lg:border-l lg:border-t-0 lg:pl-16 lg:pt-0" data-id="element-51" data-mp="3t6ni0qbrvbmm">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-coral" data-id="element-52" data-mp="1yhxzlf1wstu">
                Con +300 Mapas Mentales de Inglés™
              </p>
              <h3 className="mt-4 font-display text-2xl leading-tight text-ink sm:text-3xl" data-id="element-53" data-mp="3oe423mpm44en">
                Un sistema visual para entender, recordar y avanzar
              </h3>
              <ul className="mt-8 space-y-5" data-id="element-54" data-mp="kpive50iwgba">
                {afterList.map(item => <li key={item} className="flex gap-4" data-id="element-55" data-mp="krvl54civuyw">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-moss" aria-hidden="true" data-id="element-56" data-mp="ukq2i76ti18b" />
                    <span className="text-base leading-relaxed text-ink/75" data-id="element-57" data-mp="pmepxop51cme">{item}</span>
                  </li>)}
              </ul>
            </article>
          </div>

          
        </div>
      </div>
    </section>;
}